module.exports = __webpack_public_path__ + "static/media/fulls.250e1b47.svg";